import React from 'react';
import { graphql } from 'react-apollo';
import { SensorsQuery } from '../queries'

export const SensorsPageComponent = ({
    data:{ loading, error, sensors } 
}) =>{
    if (loading) {
      return (
        <div>
            <p>Loading ...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div>
           <p>{error.message}</p>
        </div>
      );
    }

    var sensorItems = sensors.items.map( (sensor, key) => {
        return (
            <details key={key} className="m-2">
            <summary>{sensor.id}</summary>
                <ul>
                    <li className="ml-4 mt-1"> Name: {sensor.name}</li>
                    <li className="ml-4 mt-1"> Room: {sensor.room}</li>
                    <li className="ml-4 mt-1"> LightsOnHighTemp: {sensor.lightsOnHighTemp}</li>
                    <li className="ml-4 mt-1"> LightsOnLowTemp:{sensor.lightsOnLowTemp}</li>
                    <li className="ml-4 mt-1"> LightsOffHighTemp: {sensor.lightsOffHighTemp}</li>
                    <li className="ml-4 mt-1"> LightsOffLowTemp:{sensor.lightsOffLowTemp}</li>
                </ul>
            </details>
        );
    })


    return (
        <div>
        <h1> Sensors </h1>
        <div> {sensorItems} </div>
        <div className="invisible"> {sensors.nextToken} </div>
        </div>
    );
};

export default graphql(SensorsQuery, {
    options: props => ({
      variables: {
        limit: props.match.params.limit,
        nextToken: props.match.params.limit
      },
    }),
  })(SensorsPageComponent);


// WEBPACK FOOTER //
// ./src/routes/Sensors.js